<template>
  <div class="d-none" v-if="modalShow">
    <b-modal
      v-model="modalShow"
      class="confirmModal"
      ref="confirmModal"
      hide-header
      hide-footer
      no-close-on-backdrop
      centered
      body-class="p-4"
    >
      <div class="text-center mt-3">
        <span class="text-header" v-if="header">{{ header }}</span>
        <p class="text-text" v-if="text" v-html="text"></p>
        <p class="text-sub" v-if="subText" v-html="subText"></p>
      </div>
      <hr />
      <div class="text-center mt-3">
        <b-button variant="primary-theme" block @click="handleOkModal">
          {{ button.true.msg }}</b-button
        >
        <b-button variant="outline-secondary" block @click="handleCloseModal">
          {{ button.false.msg }}</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      required: false,
      type: String
    },
    text: {
      required: false,
      type: String
    },
    subText: {
      required: false,
      type: String
    },
    button: {
      required: false,
      type: Object,
      default: () => {
        return {
          true: {
            class: ["btn-success"],
            msg: "OK"
          },
          false: {
            class: ["btn-danger"],
            msg: "Cancel"
          }
        };
      }
    }
  },
  data() {
    return {
      modalShow: false
    };
  },
  methods: {
    show() {
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    handleOkModal() {
      this.$emit("handler", true);
      this.modalShow = false;
    },
    handleCloseModal() {
      this.modalShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmModal {
  width: auto;
}
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-header {
  font-size: 18px;
  font-weight: bold;
}
.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.25rem;
  word-wrap: break-word !important;
}
.text-sub {
  color: #afce38;
  font-size: 1.25rem;
  word-wrap: break-word !important;
}
.modal-body {
  margin: auto;
  text-align: center;
}
</style>
